import { message, Spin,Form, Input, Button, DatePicker } from 'antd';
import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { deleteMaterialRequest, getMaterialRequestsList, useGetMaterialRequest } from '../../../api/materialRequests';
import DangerButton from '../../../shared/components/buttons/DangerButton';
import PrimaryButton from '../../../shared/components/buttons/PrimaryButton';
import SecondaryButton from '../../../shared/components/buttons/SecondaryButton';
import { PAGE_SIZE } from '../../../shared/constants';
import CancelIcon from '../../../shared/svgs/CancelIcon';
import DeleteForeverIcon from '../../../shared/svgs/DeleteForeverIcon';
import EditIcon from '../../../shared/svgs/EditIcon';
import { DATE_FORMAT_FRONTEND } from '../../../shared/constants';
import dayjs, { Dayjs } from 'dayjs';
import DocumentViewer from '../../../shared/components/Upload/DocumentViewer';

const MaterialRequestDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const { data: materialRequest, isLoading } = useGetMaterialRequest(Number(id));

  const { mutateAsync: mutationDelete } = useMutation(deleteMaterialRequest, {
    onSuccess: async () => {
      message.info('Deleted!');
      queryClient.invalidateQueries({
        queryKey: ['materialRequests', 'list'],
      });
      navigate(`/admin/materialRequests`);
    },
    onError: () => {
      message.error('The action is failed! Please try again');
    },
    onSettled: () => {
      queryClient.prefetchQuery({
        queryKey: ['materialRequests', 'list', { start: 0, count: PAGE_SIZE, filter: undefined }],
        queryFn: () => getMaterialRequestsList({ start: 0, count: PAGE_SIZE, filter: undefined }),
      });
    },
  });

  const handleDelete = () => {
    mutationDelete(Number(id));
  };

  return (
    <Spin spinning={isLoading}>
      <div id="user-details-container">
        <div className="page-container">
          <div className="page-content">
            <div className="page-content-header">
              <h2 className="title-page">Material Request Details</h2>
            </div>
            <div className="details-container">
              <div className="item">
                <label>Student</label>
                <span className="value">{materialRequest?.student?.chineseName}</span>
              </div>
              <div className="item">
                <label>Quantity</label>
                <span className="value">{materialRequest?.qty}</span>
              </div>
              <div className="item">
                <label>Amount</label>
                <span className="value">{materialRequest?.amount}</span>
              </div>
              <div className="item">
                <label>Material</label>
                <span className="value">{materialRequest?.material.name}</span>
              </div>
              <div className="item">
              <label>Image</label>
                <div style={{width:'20%'}}>
                  {materialRequest && <DocumentViewer files={materialRequest?.material?.files} />}  
                </div>
                </div>
              <div className="item">
                <label>Status</label>
                <span className={`value status ${materialRequest?.status=="Done" ? 'active' : 'inactive'}`}>
                  {materialRequest?.status=="Done" ? 'Done' : 'Pending'}
                </span>
              </div>
              <div className="item">
                <label>is Paid</label>
                <span className={`value status ${materialRequest?.isPaid ? 'active' : 'inactive'}`}>
                  {materialRequest?.isPaid ? 'Paid' : 'unPaid'}
                </span>
              </div>
              <div className="item">
                <label>createdAt</label>
                <span className="value">
                {dayjs(materialRequest?.createdAt).format(DATE_FORMAT_FRONTEND)}
                </span>
              </div>
              <div className="item">
                <label>updatedAt</label>
                <span className="value">
                {dayjs(materialRequest?.updatedAt).format(DATE_FORMAT_FRONTEND)}
                </span>
              </div>
            </div>
            <div className="page-content-footer">
              <Link to={`/admin/materialRequests/${id}/edit`}>
                <PrimaryButton label="Edit" icon={<EditIcon />} />
              </Link>
              <DangerButton label="Delete" onOk={handleDelete} icon={<DeleteForeverIcon />} />
              <Link to={`/admin/materialRequests`}>
                <SecondaryButton label="Cancel" icon={<CancelIcon />} />
              </Link>
            </div>
          </div>
        </div>
      </div>
     


</Spin>
  );
};

export default MaterialRequestDetailsPage;
